module.exports = __webpack_public_path__ + "static/media/business.d13acfc3.svg";